<template>
  <div class="container">
    <SectionSearchWindow @search="search" @sectionDownload="sectionDownload"/>
    <SectionSearchResult :sectionList="sectionList" :isExistSearchResult="isExistSearchResult"/>
  </div>
</template>

<script>
import SectionSearchWindow from '@/components/pages/SectionSearchWindow'
import SectionSearchResult from '@/components/pages/SectionSearchResult'

export default {
  name: 'section-list',

  props: {
    message: null
  },

  data () {
    return {
      screenTitle: '[マスタ設定] 拠点一覧',
      sectionList: [],
      isExistSearchResult: false
    }
  },

  mounted () {
    this.$emit('setScreenTitle', this.screenTitle)
  },

  async created () {
    this.$emit('setMessage', this.message, false)
    // 拠点情報操作（一括取得）API
    await this.axios.get('/api/section/getall', {
      headers: {
        'Authorization': this.$session.get('accessToken'),
        'Content-Type': 'application/json;charset=UTF-8',
        'Access-Control-Allow-Origin': '*'
      }
    }).then((response) => {
      this.sectionList = response.data
      if (this.sectionList.length > 0) {
        this.isExistSearchResult = true
      } else {
        this.isExistSearchResult = false
      }
    })
  },

  methods: {
    async search (enterpriseCode, sectionCode) {
      this.$emit('setMessage', null, false)
      var params = {
        enterpriseCode: enterpriseCode,
        sectionCode: sectionCode
      }
      // 拠点情報操作（取得）API
      await this.axios.get('/api/section/get', {
        params: params,
        headers: {
          'Authorization': this.$session.get('accessToken'),
          'Content-Type': 'application/json;charset=UTF-8',
          'Access-Control-Allow-Origin': '*'
        }
      }).then((response) => {
        this.sectionList = response.data
        if (this.sectionList.length > 0) {
          this.isExistSearchResult = true
        } else {
          this.isExistSearchResult = false
        }
      })
    },
    async sectionDownload (enterpriseCode, sectionCode) {
      this.$emit('setMessage', null, false)
      var params = {
        enterpriseCode: enterpriseCode,
        sectionCode: sectionCode
      }
      // 拠点情報一覧ダウンロードAPI
      await this.axios.get('/api/section/download', {
        params: params,
        headers: {
          'Authorization': this.$session.get('accessToken'),
          'Content-Type': 'application/json;charset=UTF-8',
          'Access-Control-Allow-Origin': '*'
        },
        responseType: 'blob'
      }).then((response) => {
        var execDate = this.$moment(response.headers.date).format('YYYYMMDD_HHmmss')
        this.downloadCSV(response.data, execDate)
      })
    },
    downloadCSV (sectionDataList, execDate) {
      let blob = new Blob([sectionDataList], { type: 'text/csv' })
      let link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = '拠点一覧_' + execDate + '.csv'
      link.click()
    }
  },

  components: {
    SectionSearchWindow,
    SectionSearchResult
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/components/pages/SectionList.vue